import { messages } from "../lib/messages";
import { FullScreenMessage } from "./FullScreenMessage";

/** NoTelegramScreen — приложение открыто не внутри Telegram, initData недоступен. */
export function NoTelegramScreen() {
  return (
    <FullScreenMessage
      testId="shop-no-telegram"
      title={messages.openInTelegram}
      description={messages.openInTelegramHint}
    />
  );
}
